(function($) {

    // Toggle collapse on submenu
    $('#navbarToggle').on('click', function() {
        var primaryNavigation = $('#primaryNavigation');
        $this = $(this);

        // Dropdown toggle setup
        if(primaryNavigation.hasClass('is-active')) {
            primaryNavigation.removeClass('is-active');
            $('body').removeClass('no-scroll');
            $this.addClass('collapsed');

        } else {
            primaryNavigation.addClass('is-active');
            $('body').addClass('no-scroll');
            $this.removeClass('collapsed');
        }
    });

    $('.js-nav-close').on('click', function() {
        var primaryNavigation = $('#primaryNavigation');
        var siteHeader = $('#siteHeader');

        primaryNavigation.removeClass('is-active');
        $('body').removeClass('no-scroll');
        siteHeader.removeClass('nav-open');
    });

    $('.navbar-primary .menu-item-has-children >a').on('click', function(e) {
        e.preventDefault();
        if($(this).parent().hasClass('show-sub')) {
            $(this).parent().removeClass('show-sub');
        } else {
            $('.navbar-primary .menu-item-has-children').each(function() {
                $(this).removeClass('show-sub');
            })
            $(this).parent().toggleClass('show-sub');
        }
    });


    $('.footer-nav >.menu-item .has-children').on('click', function(e) {
        e.preventDefault();
        if($(this).parent().hasClass('show-sub')) {
            $(this).parent().removeClass('show-sub');
        } else {
            $('.footer-nav >.menu-item').each(function() {
                $(this).removeClass('show-sub');
            })
            $(this).parent().toggleClass('show-sub');
        }
    });

}(jQuery));
